import { ajaxCall, ajaxCallBlob, formRequestData } from './ajaxService';

const constants = window.getConfig;
const ajaxPartComponentsUrl = `${constants.ajax.baseUrl}/partComponents`;

export const ajaxGetPartComponents = () =>
  new Promise((res, rej) => {
    ajaxCall(ajaxPartComponentsUrl, formRequestData(constants.ajax.methods.get, true, false))
      .then(res)
      .catch(rej);
  });

export const ajaxGetPartComponent = (id) =>
  new Promise((res, rej) => {
    ajaxCall(`${ajaxPartComponentsUrl}/${id}`, formRequestData(constants.ajax.methods.get, true, false))
      .then(res)
      .catch(rej);
  });

export const ajaxSavePartComponent = (data) =>
  new Promise((res, rej) => {
    ajaxCall(`${ajaxPartComponentsUrl}/save`, formRequestData(constants.ajax.methods.post, true, false, data, true))
      .then(res)
      .catch(rej);
  });

export const ajaxDeletePartComponent = (id) =>
  new Promise((res, rej) => {
    ajaxCall(`${ajaxPartComponentsUrl}/delete/${id}`, formRequestData(constants.ajax.methods.delete, true, false))
      .then(res)
      .catch(rej);
  });

export const ajaxDeletePartComponentImage = (id) =>
  new Promise((res, rej) => {
    ajaxCall(`${ajaxPartComponentsUrl}/deleteImage/${id}`, formRequestData(constants.ajax.methods.post, true, false))
      .then(res)
      .catch(rej);
  });

export const ajaxGetPartComponentImageUrl = async (id) => {
  try {
    const blobRes = await ajaxCallBlob(`${ajaxPartComponentsUrl}/image/${id}`, formRequestData(constants.ajax.methods.get, true, false));
    const objectUrl = window.URL.createObjectURL(blobRes.blob);
    return objectUrl;
  } catch (error) {
    console.log(error.message);
  }
};

export const ajaxEnablePartComponent = (id) =>
  new Promise((res, rej) => {
    ajaxCall(`${ajaxPartComponentsUrl}/enable/${id}`, formRequestData(constants.ajax.methods.put, true, false))
      .then(res)
      .catch(rej);
  });

export const ajaxDisablePartComponent = (id) =>
  new Promise((res, rej) => {
    ajaxCall(`${ajaxPartComponentsUrl}/disable/${id}`, formRequestData(constants.ajax.methods.put, true, false))
      .then(res)
      .catch(rej);
  });

export const ajaxGetPartStatistics = (id, data) =>
  new Promise((res, rej) => {
    ajaxCall(`${ajaxPartComponentsUrl}/statistics/${id}`, formRequestData(constants.ajax.methods.post, true, false, data))
      .then(res)
      .catch(rej);
  });
